import React from 'react'
import PowerGenBreadCrumb from './PowerGenBreadCrumb';
import PowerDashboard from './PowerDashboard';
function PowerDashboardPage() {
    return ( 
        <div className="container-fluid">
            <>
            <PowerGenBreadCrumb />
            <PowerDashboard />
            </>
        </div>
     );
}

export default PowerDashboardPage;